import React, { useState, useEffect } from "react";
import Mainheader from "../components/MainHeader/Mainheader";
import { Link, useLocation, useNavigate } from "react-router";
import Button from "react-bootstrap/Button";
import { cityListApi, signUpApi } from "../services/apiService";
import { toast } from "react-toastify";
import ExclamationIcon from "../assets/images/exclamation.svg";
import Nopreview from "../assets/images/Nopreview.svg";
import Preview from "../assets/images/preview.svg";

import { useCities } from "@/queries/useLocalisationQuery"

const RegisterCreatePassword = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [medicalHisChecked, setMedicalHisChecked] = useState(true);
  const [cityList, setCityList] = useState([]);
  const [passVisible, setPassVisible] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handlevarification = () => {
    // Perform login logic here
    navigate("/verification");
  };

  const [formDataSignup, setFormDataSignup] = useState({
    first_name: "",
    last_name: "",
    city_id: "",
    email: "",
    cell_phone: "",
    month: "",
    day: "",
    year: "",
    password: "",
    id_number: "",
    gender: "",
    patient_address: "",
    birth_city_id: "",
  });

  const [formErrorsSignup, setFormErrorsSignup] = useState({
    first_name: "",
    last_name: "",
    city_id: "",
    email: "",
    cell_phone: "",
    month: "",
    day: "",
    year: "",
    password: "",
    id_number: "",
    gender: "",
    birth_city_id: "",
    // patient_address: "",
  });

  const handleChangeSignup = e => {
    const { name, value } = e.target;
    setFormDataSignup({ ...formDataSignup, [name]: value });
    setFormErrorsSignup({ ...formErrorsSignup, [name]: "" });
  };

  const { data: cities } = useCities()

  const getCityList = async () => {
    try {
      if (cities) {
        setCityList(cities);
      } else {
        throw new Error("Error fetching cities because response is : ", cities);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const validateFormSignup = () => {
    let isValid = true;
    const errors = {
      first_name: "",
      last_name: "",
      city_id: "",
      email: "",
      cell_phone: "",
      month: "",
      day: "",
      year: "",
      password: "",
      id_number: "",
      gender: "",
      birth_city_id: "",
      // patient_address: "",
    };

    if (formDataSignup.first_name === "") {
      errors.first_name = "Please enter your first name";
      isValid = false;
    } else if (/[\u0600-\u06FF]/.test(formDataSignup.first_name)) {
      errors.first_name = "First name cannot contain Arabic characters.";
      isValid = false;
    }

    if (formDataSignup.last_name === "") {
      errors.last_name = "Please enter your last name";
      isValid = false;
    } else if (/[\u0600-\u06FF]/.test(formDataSignup.last_name)) {
      errors.last_name = "Last name cannot contain Arabic characters.";
      isValid = false;
    }

    if (formDataSignup.city_id === "") {
      errors.city_id = "Please select city";
      isValid = false;
    }

    if (formDataSignup.email === "") {
      errors.email = "Please enter email";
      isValid = false;
    }

    if (formDataSignup.cell_phone === "") {
      errors.cell_phone = "Please enter your phone number";
      isValid = false;
    }

    if (formDataSignup.cell_phone && !/^\d{5,10}$/.test(formDataSignup.cell_phone)) {
      errors.cell_phone = "Phone number is not valid.";
      isValid = false;
    }

    if (formDataSignup.month === "") {
      errors.month = "Please select month";
      isValid = false;
    }

    if (formDataSignup.day === "") {
      errors.day = "Please select day";
      isValid = false;
    }

    if (formDataSignup.year === "") {
      errors.year = "Please select year";
      isValid = false;
    }

    if (formDataSignup.birth_city_id === "") {
      errors.birth_city_id = "Please select birth city.";
      isValid = false;
    }

    if (formDataSignup.password === "") {
      errors.password = "Please enter your password";
      isValid = false;
    } else if (!/(?=^.{8,}$)(?=.*\d)(?=.*[!@#$%^&*]+)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(formDataSignup.password)) {
      errors.password =
        "Password must be at least 8 characters long, must contain at least one digit, one special character, one uppercase letter, one lowercase letter.";
      isValid = false;
    }

    if (formDataSignup.id_number === "") {
      errors.id_number = "Please enter id number.";
      isValid = false;
    }

    if (formDataSignup.id_number && !/^\d{9}$/.test(formDataSignup.id_number)) {
      errors.id_number = "Invalid Id Number. It must be exactly 9 digits.";
      isValid = false;
    }

    if (formDataSignup.gender === "") {
      errors.gender = "Please select gender.";
      isValid = false;
    }

    // if (formDataSignup.patient_address === "") {
    //   errors.patient_address = "Please enter address.";
    //   isValid = false;
    // }

    setFormErrorsSignup(errors);
    return isValid;
  };

  const handleSignup = async e => {
    try {
      e.preventDefault();
      if (validateFormSignup()) {
        setIsSubmitting(true);
        if (medicalHisChecked) {
          formDataSignup.allow_refer = "1";
          formDataSignup.show_medical_history = "1";
        } else {
          formDataSignup.allow_refer = "0";
          formDataSignup.show_medical_history = "0";
        }
        let apiRes = await signUpApi(formDataSignup);
        let responseData = apiRes;

        if (responseData.data.res == false) {
          //setErrorMessage(responseData.data.msg)
          toast.error(responseData.data.msg, { autoClose: 1500 });
          setIsSubmitting(false);
        } else {
          // console.warn(response.data.data.authorisation.token)
          // const token = response.data.data.authorisation.token;
          // localStorage.setItem("wealthNexusLoginInfo", JSON.stringify(response.data.data));
          // let value = JSON.parse(localStorage.getItem("wealthNexusLoginInfo"));
          // console.warn(response.data.data);

          navigate("/verification", { state: { id: responseData.data.data.id, from: location?.state?.from } });
        }
      }
    } catch (error) {
      setIsSubmitting(false);
      console.error(error);
    }
  };

  const daysarray = [];
  for (let i = 1; i <= 31; i++) {
    daysarray.push(i);
  }

  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 100;
  const years = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }

  const handleKeyPress = e => {
    const charCode = e.charCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  useEffect(() => {
    getCityList();
    let value = JSON.parse(localStorage.getItem("doctolikLoginInfo")); //JSON.parse(secureLocalStorage.getItem('loginInfo'));
    if (value != undefined) {
      navigate("/");
    }
  }, []);

  return (
    <div className="Main">
      <Mainheader />
      <div className="Fullbody">
        <div className="RegBox">
          <h3>Register</h3>
          <h4>Sign Up for free</h4>
          <h5>Enter your information to continue.</h5>

          {successMessage && <div className="success-message">{successMessage}</div>}
          {errorMessage && <div className="error">{errorMessage}</div>}

          <form className="login-form" onSubmit={handleSignup}>
            <div className="input-group">
              <input
                type="tel"
                placeholder="Phone Number"
                className={`telInput ${formErrorsSignup.cell_phone ? "inputHaveError" : ""}`}
                name="cell_phone"
                value={formDataSignup.cell_phone}
                onChange={handleChangeSignup}
                onKeyPress={handleKeyPress}
                inputMode="numeric"
                maxLength="10"
              />
              {formErrorsSignup.cell_phone && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} /> {formErrorsSignup.cell_phone}
                </span>
              )}
            </div>
            <label className="labelTxt">A code will be sent to you on this number to validate your account.</label>
            <div className="input-group">
              <input
                type="text"
                placeholder="First name (in French letters)"
                className={`telInput ${formErrorsSignup.first_name ? "inputHaveError" : ""}`}
                maxLength="50"
                name="first_name"
                value={formDataSignup.first_name}
                onChange={handleChangeSignup}
              />
              {formErrorsSignup.first_name && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} />
                  {formErrorsSignup.first_name}
                </span>
              )}
            </div>
            <div className="input-group">
              <input
                type="text"
                placeholder="Last name (in French letters)"
                className={`telInput ${formErrorsSignup.last_name ? "inputHaveError" : ""}`}
                maxLength="50"
                name="last_name"
                value={formDataSignup.last_name}
                onChange={handleChangeSignup}
              />
              {formErrorsSignup.last_name && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} />
                  {formErrorsSignup.last_name}
                </span>
              )}
            </div>
            <div className="input-group">
              <div className="select-style">
                <select name="gender" className={`${formErrorsSignup.gender ? "inputHaveError" : ""}`} onChange={handleChangeSignup}>
                  <option value="" disabled selected>
                    Select Gender
                  </option>
                  <option value={"male"}>Male</option>
                  <option value={"female"}>Female</option>
                  {/* <option value={"other"}>Other</option> */}
                </select>
              </div>
              {formErrorsSignup.gender && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} />
                  {formErrorsSignup.gender}
                </span>
              )}
            </div>
            <div className="input-group">
              <div className="select-style">
                <select name="city_id" className={`${formErrorsSignup.city_id ? "inputHaveError" : ""}`} onChange={handleChangeSignup}>
                  <option value="" disabled selected>
                    Select City
                  </option>
                  {cityList?.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              {formErrorsSignup.city_id && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} />
                  {formErrorsSignup.city_id}
                </span>
              )}
            </div>
            {/* <div className="input-group">
              <input
                type="text"
                placeholder="Address"
                className={`telInput ${formErrorsSignup.patient_address ? "inputHaveError" : ""}`}
                name="patient_address"
                value={formDataSignup.patient_address}
                onChange={handleChangeSignup}
              />
              {formErrorsSignup.patient_address && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} />
                  {formErrorsSignup.patient_address}
                </span>
              )}
            </div> */}
            <label className="labelTxt2">Date of birth</label>
            <div className="inputRow positionRelativeClass">
              <div className="input-group">
                <div className="select-style">
                  <select
                    className={`${formErrorsSignup.month || formErrorsSignup.day || formErrorsSignup.year ? "inputHaveError" : ""}`}
                    name="month"
                    onChange={handleChangeSignup}>
                    <option value="" disabled selected>
                      Month
                    </option>
                    {months?.map((item, index) => (
                      <option key={index} value={index + 1}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {/* {formErrorsSignup.month && <span className="error">{formErrorsSignup.month}</span>} */}

              <div className="input-group">
                <div className="select-style">
                  <select
                    name="day"
                    onChange={handleChangeSignup}
                    className={`${formErrorsSignup.month || formErrorsSignup.day || formErrorsSignup.year ? "inputHaveError" : ""}`}>
                    <option value="" disabled selected>
                      Day
                    </option>
                    {daysarray?.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {/* {formErrorsSignup.day && <span className="error">{formErrorsSignup.day}</span>} */}

              {/* <div className="input-group dayInput">
                <input type="text" placeholder="Day" className="telInput" />
              </div> */}

              <div className="input-group">
                <div className="select-style">
                  <select
                    name="year"
                    onChange={handleChangeSignup}
                    className={`${formErrorsSignup.month || formErrorsSignup.day || formErrorsSignup.year ? "inputHaveError" : ""}`}>
                    <option value="" disabled selected>
                      Year
                    </option>
                    {years?.map((year, index) => (
                      <option key={index} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {(formErrorsSignup.month || formErrorsSignup.day || formErrorsSignup.year) && (
                <span className="vaidationError bottomZeroCls">
                  <img className="exclamationIcon" src={ExclamationIcon} />
                  Please enter date of birth.
                </span>
              )}
              {/* {formErrorsSignup.year && <span className="error">{formErrorsSignup.year}</span>} */}
            </div>
            <div className="input-group">
              <div className="select-style">
                <select name="birth_city_id" className={`${formErrorsSignup.birth_city_id ? "inputHaveError" : ""}`} onChange={handleChangeSignup}>
                  <option value="" disabled selected>
                    Select Birth City
                  </option>
                  {cityList?.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              {formErrorsSignup.birth_city_id && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} />
                  {formErrorsSignup.birth_city_id}
                </span>
              )}
            </div>
            <div className="input-group">
              <input
                type="email"
                placeholder="Email address"
                className={`telInput ${formErrorsSignup.email ? "inputHaveError" : ""}`}
                name="email"
                value={formDataSignup.email}
                onChange={handleChangeSignup}
              />
              {formErrorsSignup.email && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} />
                  {formErrorsSignup.email}
                </span>
              )}
            </div>
            <div className="input-group">
              <input
                type={passVisible ? "text" : "password"}
                placeholder="Password"
                className={`telInput ${formErrorsSignup.password ? "inputHaveError" : ""}`}
                name="password"
                value={formDataSignup.password}
                onChange={handleChangeSignup}
              />
              <span className="password-icon" onClick={() => setPassVisible(!passVisible)}>
                <img src={passVisible ? Nopreview : Preview} alt="Toggle Password Visibility" />
              </span>
              {formErrorsSignup.password && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} />
                  {formErrorsSignup.password}
                </span>
              )}
            </div>
            <div className="input-group">
              <input
                type="number"
                placeholder="Id Number"
                className={`telInput ${formErrorsSignup.id_number ? "inputHaveError" : ""}`}
                name="id_number"
                value={formDataSignup.id_number}
                onChange={handleChangeSignup}
              />
              {formErrorsSignup.id_number && (
                <span className="vaidationError">
                  <img className="exclamationIcon" src={ExclamationIcon} />
                  {formErrorsSignup.id_number}
                </span>
              )}
            </div>
            <label className="labelTxt">Your password will allow you to manage your medical appointments.</label>
            {/* <button type="submit" className="login-button">
              Sign Up
            </button> */}
            {isSubmitting ? (
              <Button className="login-button" variant="primary" type="submit" disabled>
                Please wait...
              </Button>
            ) : (
              <Button className="login-button" variant="primary" type="submit">
                Sign Up
              </Button>
            )}
            <p className="createLink checkbox-style longText">
              <label>
                <input type="checkbox" name="terms" value="accepted" checked={medicalHisChecked} onChange={e => setMedicalHisChecked(e.target.checked)} />
                Permit your doctor to access your medical history during the consultation and consult with other doctors if needed.
              </label>
            </p>
            <p className="createLink checkbox-style">
              <label>
                <input type="checkbox" name="terms" value="accepted" required />I agree to the terms and conditions
              </label>
            </p>
            <p className="createLink">
              I already have a doctolik account <Link to="/patient/login">To Login</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterCreatePassword;
